export default __webpack_public_path__ + "static/newspaper-b6e84e74d76688d75f97b196eab6235d.png";